import React, { createContext, useMemo, useReducer } from 'react';
import { imageHandlers, imageInitialState, imageReducer } from '../reducers/ImageReducer';

export const ImageContext = createContext();

const ImageProvider = (props) => {

  const init_state = {}
  const [image_state, image_dispatch] = useReducer(imageReducer, init_state, imageInitialState)

  const image_handlers = useMemo(
    () => imageHandlers(image_dispatch),
    [image_dispatch]
  );

  return <ImageContext.Provider value={{ image_state, image_handlers }}>
    {props.children}
  </ImageContext.Provider>
}

export default ImageProvider